import { gql } from '../__generated__';

export const RECOMMENDED_COMPANIES_QUERY = gql(`
  query xcpRecommendedCompanies($first: Int, $after: String) {
    viewer {
      id
      companiesRecommendations(first: $first, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            company {
              ...CompanyData              
            }
            dismissible
          }
        }
      }
    }
  }
`);
